const OFFER_ACTION_WINDOW_MS = 48 * 60 * 60 * 1000;

export function useOfferTiming(sendDate) {
  if (!sendDate) return null;

  const sentAt = new Date(sendDate).getTime();
  const expiryAt = sentAt + OFFER_ACTION_WINDOW_MS;
  const now = Date.now();

  const timeLeftMs = expiryAt - now;

  return {
    isExpired: timeLeftMs <= 0,
    hoursLeft: Math.max(0, Math.ceil(timeLeftMs / (1000 * 60 * 60))),
    expiresAt: expiryAt,
  };
}
